<template>
  <section class="footer">
    <VFooter app>
      <VCard flat tile width="100%" density="compact">
        <VCardTitle class="help">
          Besoin d'aide ?
          <VBtn
            icon="mdi-frequently-asked-questions"
            href="https://engie.sharepoint.com/:f:/r/sites/portailgm/Documents partages/1-Documents Utilisateurs/eDayWork?csf=1&web=1&e=Xpws1C"
            target="_blank"
            base-color="transparent"
            variant="flat"
            density="compact"
          />
        </VCardTitle>

        <VCardText class="py-2 text-center">
          <span v-if="isRGPDDisplayed" class="edaywork-RGPD-mentions">
            <RgpdMention />
          </span>
        </VCardText>
      </VCard>
    </VFooter>
  </section>
</template>

<script lang="ts" setup>
import RgpdMention from '@/components/RgpdMention.vue';
import { computed } from 'vue';
import useUserStore from '@/stores/userStore.ts';

const userStore = useUserStore();

const isRGPDDisplayed = computed(() => {
  return (
    userStore.user.gid && (userStore.user.roles.isExec || userStore.user.roles.isHR || userStore.user.roles.isManager)
  );
});
</script>

<style lang="scss" scoped>
@use '@/styles/colors';

.footer {
  z-index: 1006;

  :deep(.v-footer) {
    left: 0 !important;
    width: 100% !important;
    padding: 0;
  }

  :deep(.v-card-text) {
    background-color: colors.$black;
    color: colors.$white;
  }
}
.help {
  padding: 5px 5px 5px 10px;
  font-size: 0.88em;
  background-color: rgb(var(--v-theme-primary-darken-3));
  color: colors.$white;
}

.edaywork-RGPD-mentions {
  font-weight: bold;
}
</style>
